import { fetchTicketCounts } from '@/services/supportApi'

export const support = {
  namespaced: true,
  state: () => ({
    counts: { open: 0, mine: 0, unassigned: 0 },
  }),
  mutations: {
    SET_COUNTS(state, counts) {
      state.counts = counts
    },
    RESET_STATE(state) {
      state.counts = { open: 0, mine: 0, unassigned: 0 }
    },
  },
  actions: {
    async loadCounts({ commit }) {
      try {
        commit('SET_COUNTS', await fetchTicketCounts())
      } catch (e) {
        // Badge only: ignore failures.
      }
    },
  },
}
